module.exports = __webpack_public_path__ + "static/BannerImage.47666748.png";